import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterOutlet, RouterModule, Router } from '@angular/router';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { Subject } from 'rxjs';
import { NgbCollapse, NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ComboService } from '../../../Model/Combo/combo.service';
import { CommonService } from '../../../Model/Common/common.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { LetterDocumentService } from '../../../Model/LetterDocument/letter-document.service';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';

@Component({
  selector: 'app-letter-generate-form',
  standalone: true,
  imports: [FormsModule, CommonModule, LoaderComponent, RouterOutlet, RouterModule, DataTablesModule, NgbDatepickerModule, NgSelectModule, NgbCollapse],
  templateUrl: './letter-generate-form.component.html',
  styleUrl: './letter-generate-form.component.scss'
})
export class LetterGenerateFormComponent {
  isDisabled: boolean = false;
  Branchs = [];
  Clients = [];
  Sites = [];
  Templates = [];
  LetterTypes = [];
  EmployeeStatus = [];
  isCollapsed = false;
  user = [] as any;

  Filter = {
    BranchID: null,
    ClientID: null,
    SiteID: null,
    EmpID: null,
    EmpType: 'Front',
    LetterTemplateId: null,
    LetterTypeId: null,
    ESS_LetterModuleTypeId: null,
    //isResigned : false
  }

  TableDatas: any[] = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private dateFormat: CustomDateParserFormatter,
    protected common: CommonService,
    private session: SessionService,
    private toast: ToastService,
    private tooltip: TooltipService,
    private modalService: NgbModal,
    private combo: ComboService,
    private utility: UtilityService,
    private letterDocument: LetterDocumentService,
    private router: Router,
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ComboLoad('Branch');
    this.ComboLoad('ESS_LetterModuleType');
    //this.ESSLetterDocumentTypeMasterSelect();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    if (Combotype == 'Site') {
      this.Filter.SiteID = null;
      this.Sites = [];
    } else if (Combotype == 'Client') {
      this.Filter.ClientID = null;
      this.Filter.SiteID = null;
      this.Clients = [];
      this.Sites = [];
    } else if (Combotype == 'ESS_LetterModuleType') {
      this.EmployeeStatus = [];
    }

    this.combo.ComboLoad({
      'Combotype': Combotype, 'BranchId': this.Filter.BranchID, 'ClientId': this.Filter.ClientID, 'SiteId': this.Filter.SiteID, 'DesignationId': null, 'EmpType': this.Filter.EmpType, 'EmpMasterID': this.user.UserId
    }).subscribe({
      next: (response) => {
        if (response.ComboLoad) {
          if (Combotype == 'Branch') {
            this.Branchs = response.ComboLoad;
          } else if (Combotype == 'Client') {
            this.Clients = response.ComboLoad;
          } else if (Combotype == 'Site') {
            this.Sites = response.ComboLoad;
          } else if (Combotype == 'ESS_LetterModuleType') {
            this.EmployeeStatus = response.ComboLoad;
          }
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESSLetterTemplateMasterSelect() {
    this.Templates = [];
    this.Filter.LetterTemplateId = null
    if (this.Filter.LetterTypeId != null && this.Filter.LetterTypeId != '' && this.Filter.LetterTypeId > 0) {
      this.isDisabled = true;
      this.letterDocument.ESSLetterTemplateMasterSelect({ ESS_LetterTemplateMasterID: 0, ESS_LetterDocumentTypeMasterID: this.Filter.LetterTypeId, SelectType: 2 }).subscribe({
        next: (response) => {
          if (response.Table) {
            this.Templates = response.Table;
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    }
  }

  ESSLetterDocumentTypeMasterSelect() {
    this.LetterTypes = [];
    this.Filter.LetterTypeId = null;

    this.Templates = [];
    this.Filter.LetterTemplateId = null;

    this.isDisabled = true;
    this.letterDocument.ESSLetterDocumentTypeMasterSelect({ ESS_LetterDocumentTypeMasterID: 0, SelectType: 2, ESS_LetterModuleTypeId: this.Filter.ESS_LetterModuleTypeId }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.LetterTypes = response.Table;
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  FilterValidate(form: any) {
    if (form.valid) {
      this.isCollapsed = true;
      this.ESS_LetterTemplate_LoadEmpForLetter();
    }
    else {
      form.submitted = true;
    }
  }

  ESS_LetterTemplate_LoadEmpForLetter() {
    this.isDisabled = true;
    this.letterDocument.ESS_LetterTemplate_LoadEmpForLetter(this.Filter).subscribe({
      next: (response) => {
        if (response.Table) {
          this.TableDatas = Object.values(response.Table);
        } else {
          this.TableDatas = Object.values([]);
        }
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Check(event: any, i: number, IsAll = false) {
    if (IsAll) {
      this.TableDatas.map((e: any) => e.IsCheck = event.target.checked);
    } else {
      this.TableDatas[i].IsCheck = event.target.checked;
    }
  }

  ESS_LetterTemplateGenerationRequest_InsertUpdate() {
    if (this.common.PageRight.IsAdd) {
      if (this.Filter.LetterTemplateId != null && this.Filter.LetterTemplateId != '' && this.Filter.LetterTemplateId > 0) {
        if (this.TableDatas.filter(e => e.IsCheck).length > 0) {
          const modalRef = this.modalService.open(ConfirmationComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = 'Do you want to generate letter';
          modalRef.result.then(async (result: any) => {
            if (result) {
              this.isDisabled = true;
              if (this.TableDatas.filter(e => e.IsCheck).length > 1) {
                //console.log('SelectType :' ,'I', 'EmpMasterId:',this.TableDatas.filter(e => e.IsCheck).map(e => e.EmpMasterID).toString(), 'LetterTemplateId:', this.Filter.LetterTemplateId, 'SessionBatchNo:' ,Date.now().toString() );

                this.letterDocument.ESS_LetterTemplateGenerationRequest_InsertUpdate({ 'SelectType': 'I', 'EmpMasterId': this.TableDatas.filter(e => e.IsCheck).map(e => e.EmpMasterID).toString(), LetterTemplateId: this.Filter.LetterTemplateId, SessionBatchNo: Date.now().toString() }).subscribe({
                  next: (response) => {
                    if (response.Error_Code == '540') {
                      const modalRef = this.modalService.open(AlertSuccessComponent, {
                        size: 'md',
                        backdrop: 'static',
                        centered: true,
                        windowClass: 'confirmation-modal'
                      });
                      modalRef.componentInstance.Message = response.Error_Message;
                      modalRef.result.then((result: any) => {
                        if (result) {
                          this.ESS_LetterTemplate_LoadEmpForLetter();
                        }
                      });
                    }
                    else {
                      const modalRef = this.modalService.open(AlertWarningComponent, {
                        size: 'md',
                        backdrop: 'static',
                        centered: true,
                        windowClass: 'confirmation-modal'
                      });
                      modalRef.componentInstance.Message = response.Error_Message;
                      modalRef.result.then((result: any) => { });
                    }
                    this.isDisabled = false;
                  },
                  complete: () => { },
                  error: (error) => {
                    this.isDisabled = false;
                  },
                });
              } else {
                // console.log('SelectType :' ,'I', 'EmpMasterId:',this.TableDatas.filter(e => e.IsCheck).map(e => e.EmpMasterID).toString(), 'LetterTemplateId:', this.Filter.LetterTemplateId, 'SessionBatchNo:' ,Date.now().toString() );

                this.letterDocument.ESS_LetterTemplateGenerationRequest_GenerateOneLetter({ 'SelectType': 'I', 'EmpMasterId': this.TableDatas.filter(e => e.IsCheck).map(e => e.EmpMasterID).toString(), LetterTemplateId: this.Filter.LetterTemplateId, SessionBatchNo: Date.now().toString() }).subscribe({
                  next: (response) => {
                    if (response.Error_Code == '556') {
                      const modalRef = this.modalService.open(AlertSuccessComponent, {
                        size: 'md',
                        backdrop: 'static',
                        centered: true,
                        windowClass: 'confirmation-modal'
                      });
                      modalRef.componentInstance.Message = response.Error_Message;
                      modalRef.result.then((result: any) => {
                        if (result) {
                          if (response.Template_url && response.Template_url != null && response.Template_url != '') {
                            window.open(this.Link(this.Templates.filter((e: any) => e.ESS_LetterTemplateMasterID == this.Filter.LetterTemplateId)[0]['LetterCode'] + '/' + response.Template_url), "_blank");
                          }

                          this.ESS_LetterTemplate_LoadEmpForLetter();
                        }
                      });
                    }
                    else {
                      const modalRef = this.modalService.open(AlertWarningComponent, {
                        size: 'md',
                        backdrop: 'static',
                        centered: true,
                        windowClass: 'confirmation-modal'
                      });
                      modalRef.componentInstance.Message = response.Error_Message;
                      modalRef.result.then((result: any) => { });
                    }
                    this.isDisabled = false;
                  },
                  complete: () => { },
                  error: (error) => {
                    this.isDisabled = false;
                  },
                });
              }

            }
          }).catch(() => { });
        } else {
          this.toast.show({ message: 'Please select atleast one employee', type: toastTypeEnum.warning });
        }
      } else {
        this.isCollapsed = false;
        this.toast.show({ message: 'Please select template', type: toastTypeEnum.warning });
      }
    }
  }

  cancel() {
    this.router.navigate(['/letter/letterreport/']);
  }

  Link(Text: string) {
    return this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + 'LetterTemplate' + '/' + Text;
  }

  clear() {
    this.TableDatas = [];
    try {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } catch (e) { }
  }
}
